import { BaseService } from '../../base/base.service';
import { AppService } from '../../main/app.service';

export class IAuthSettings {
    Id: number;
    Email?: string;
}

export class AuthSettingsService extends BaseService<IAuthSettings> {
    
    constructor(AuthSettingsApi: Restangular.IService, protected AppService: AppService) {
        'ngInject';
        super(AuthSettingsApi, AppService, 'user');
    }
}


// WEBPACK FOOTER //
// ./src/app/authsettings/services/authsettings.service.ts